export default __webpack_public_path__ + "4f8e6de0ac031c905d6e96f622e486e7.svg";